module.exports = __webpack_public_path__ + "img/88009030001181.2f0d395c.png";